import Vue from 'vue'
import Vuex from 'vuex'

import VueResource from 'vue-resource';
import HttpHelper from '@/http-helper.js';
import AreaHelper from '@/area-helper.js';

Vue.use(Vuex)
Vue.use(VueResource);

const store = new Vuex.Store({
  state: {
    loading : false,
    loggedIn : false,
    inspection : null,
    inspectionID : -1,
    properties : {}, //dictionary keyed on property ID. will be updated with units as user selects each property.
    accessToken : null, //for authenticated access to our backend
    completedAreas : {}, //dictionary of area IDs that are completed. set up initially and updated whenever a room is submitted
    userMessage : '',
    showUserMessage : false,
    showUserMessageCloseButton : false,
    allAreasCompleted : false
  },
  modules: {
    HttpHelper : HttpHelper,
    AreaHelper : AreaHelper
  },
  getters : {
    areas : function( state ){
      if ( state.inspection && state.inspection.hasOwnProperty('InspectionAreas') ){
        return state.inspection.InspectionAreas;
      }else{
        return null;
      }
    },
    area: function( state ){
      return function( id ){
        if ( state.inspection && state.inspection.hasOwnProperty('InspectionAreas') && state.inspection.InspectionAreas ){
          for( let i = 0; i < state.inspection.InspectionAreas.length; i++ ){
            if( state.inspection.InspectionAreas[ i ].hasOwnProperty('InspectionAreaID') && state.inspection.InspectionAreas[ i ].InspectionAreaID == id ){
              return state.inspection.InspectionAreas[ i ];
            }
          }

        }
        return null;
      }
    },
    properties : function( state ){
      return state.properties;
    },
    property: function( state ){
      return function( id ){
        if ( state.properties.hasOwnProperty( id ) ){
          return state.properties[ id ];
        }else{
          return null;
        }
      }
    }
  },
  mutations: {
    load : function ( state ){
      state.loading = true;
    },
    ready : function ( state ){
      state.loading = false;
    },
    doLogin : function (state, payload ){
      state.accessToken = payload.token;
      state.inspectionID = payload.InspectionID;
      state.loggedIn = true;
    },
    logOut : function ( state ){
      state.loading = false;
      state.loggedIn = false;
      state.loading = false;
      state.inspection = null;
      state.inspectionID = -1;
      state.accessToken = null; //for authenticated access to our backend
      state.areas = {}; //dictionary keyed on area id
      state.completedAreas = {};
      // state.userMessage = '';
      // state.showUserMessageCloseButton = false;
      state.allAreasCompleted = false;
    },
    storeProperties : function( state, payload ){
      if ( payload.body.hasOwnProperty('status') && payload.body.status == 'OK' ){
        let properties = payload.body.result;
        for( let pid of Object.keys( properties ) ){
          if( properties[ pid ].hasOwnProperty( 'PropertyID' ) ){
            Vue.set(state.properties, properties[ pid ].PropertyID, properties[ pid ] );
          }
        }
      }
    },
    storeInspection : function( state, payload ){


      if ( payload.hasOwnProperty('body') && payload.body.hasOwnProperty('inspection') ){
        state.inspection = payload.body.inspection;
        //also store completed areas separately as dictionary
        if( payload.body.inspection.hasOwnProperty( 'InspectionAreas' ) ){
          for( let area of payload.body.inspection.InspectionAreas ){
              // Vue.set(state.areas, area.InspectionAreaID, area );
              if ( AreaHelper.actions.isCompleted( area ) ){
                Vue.set( state.completedAreas, area.InspectionAreaID, true );
              }
            }
        }

      }
    },
    storeUnits : function( state, payload ){
      if ( payload.body.hasOwnProperty('status') && payload.body.status == 'OK' ){
        let property = payload.body.result;
        //Return early if bad result or we aren't tracking this property ID for some reason
        if ( ! property.hasOwnProperty( 'PropertyID' ) ||
              ! property.hasOwnProperty( 'Units' ) ||
              ! state.properties.hasOwnProperty( property.PropertyID ) ){
          return;
        }
        Vue.set( state.properties[ property.PropertyID ], 'units', property.Units);
      }
    },
    postMessage : function( state, payload){
      if ( !payload.hasOwnProperty('msg') ){ return; }
      state.userMessage = payload.msg;
      state.showUserMessageCloseButton = false;
      state.showUserMessage = true;
      if ( payload.hasOwnProperty('timeout') ){
        if( !isNaN(parseInt(payload.timeout)) && parseInt(payload.timeout) != 0 ){
          setTimeout( function(){
            state.userMessage = '';
          }, parseInt(payload.timeout) );
        }
      }
      if ( payload.hasOwnProperty( 'allowClose' ) && payload.allowClose ){
        state.showUserMessageCloseButton = true;
      }
    },
    closeMessage : function( state ){
      state.showUserMessage = false;
      state.userMessage = '';
    },
    completeArea : function( state, areaID ){
      Vue.set(state.completedAreas, areaID, true );
    },
    markAllAreasCompleted : function( state ){
      state.allAreasCompleted = true;
    },
    markInspectionInProgress : function( state ){
      state.inspection.InspectionStatus = 'In Progress';
      //not using inspectionstatusID once loaded, so not updating
    }
  },
  actions: {
    fetchInitialData( context ){
      return new Promise( function( resolve ){
        var fetchProperties = HttpHelper.actions.fetchAndStore( context, 'properties', 'storeProperties' );
        Promise.all( [ fetchProperties ] ).then( function(){
          context.commit( 'ready' );
          resolve();
        });
      });
    },
    postMessage( context, msgObj ){
      context.commit( 'postMessage', msgObj )
    },
    closeUserMessage( context ){
      context.commit( 'closeMessage' );
    },
    login (context, credentials ){
      context.dispatch( 'postMessage', { msg : 'Logging in...', timeout : 0 });
      return HttpHelper.actions.post( 'login', credentials ).then( response => {
        if ( response.body.hasOwnProperty( 'status' ) && response.body.status == 'OK'){
            if ( response.body.hasOwnProperty( 'result' ) ){
              if ( response.body.result.hasOwnProperty( 'token' ) &&
                      response.body.result.hasOwnProperty( 'InspectionID' ) ){
                          context.dispatch( 'postMessage', { msg : 'Successfully logged in. Loading your inspection...', timeout : 0 });
                          context.commit( 'doLogin', response.body.result );
                  }
            }
        }else if ( response.body.hasOwnProperty( 'result' ) ){
          throw response.body.result;
        }
        if( !context.state.loggedIn ){ throw "Could not log in."; }
        return HttpHelper.actions.fetchWithToken( 'inspection/', context.state.accessToken );
      }).then( response => {
        if( !response.hasOwnProperty('body') ){ throw "Could not load inspection."; }
        context.commit( 'storeInspection', response );
      });
    },
    checkAllCompleted( context ){
      //check if previously examined as true
      if( context.state.allAreasCompleted ){
        context.dispatch( 'postMessage', { msg : 'You have submitted all rooms. Select "submit inspection" to send your inspection report.', timeout : 15000, allowClose : true });
        return;
      }
      //examine each area and see if all are submitted
      if( AreaHelper.actions.allAreasCompleted( context.state.inspection ) ){
        //save for future checks
        context.commit( 'markAllAreasCompleted' );
        context.dispatch( 'postMessage', { msg : 'You have submitted all rooms. Select "submit inspection" to send your inspection report.', timeout : 15000, allowClose : true });
      }
    },
    logOut( context ){
      context.commit( 'logOut' );
    },
    finalizeInspection ( context ){
      context.dispatch( 'postMessage', { msg : 'Finalizing inspection...', timeout : 0 });
      return HttpHelper.actions.fetchWithToken( 'inspection/finalize/', context.state.accessToken );
    },
    updateArea ( context, area ){
      context.dispatch( 'postMessage', { msg : 'Uploading room...', timeout : 0 });
      return HttpHelper.actions.postWithToken( 'inspection/area/', context.state.accessToken, area ).then( response => {
          if ( response.body.hasOwnProperty( 'status' ) && response.body.status == 'OK'){
            context.dispatch( 'postMessage', { msg : 'Successfully uploaded room.', timeout : 2000, allowClose : true });
            if( area.hasOwnProperty('InspectionAreaID') ){
              context.commit( 'completeArea', area.InspectionAreaID );
            }

            //If this is the first area we've sent in, we need to trigger the in-progress status which will also alert property manager
            if( context.state.inspection.hasOwnProperty('InspectionStatus')  && context.state.inspection.InspectionStatus == 'New' ){
              return HttpHelper.actions.fetchWithToken( 'inspection/inprogress/', context.state.accessToken );
            }
          }else{
            throw 'Could not upload room. Please try again.';
          }
      }).then( () => {
          context.commit( 'markInspectionInProgress' );
      });
    },
    uploadPhoto ( context, photo ){
      if( !photo.hasOwnProperty('inspectionAreaItemID') || !photo.hasOwnProperty('photo') ){
        return;
      }
      var formData = new FormData();
      formData.append('image', photo.photo);

      //console.log('Mock upload photo action called with inspectionAreaItemID', photo.inspectionAreaItemID,'and photo',photo.photo );
      return HttpHelper.actions.postBinaryWithToken( 'inspection/areaitemupload/'+photo.inspectionAreaItemID, context.state.accessToken, formData ).then( response => {
        if ( response.body.hasOwnProperty( 'status' ) && response.body.status == 'OK'){
          //context.dispatch( 'postMessage', { msg : 'Successfully uploaded room.', timeout : 6000 });
          //upload photos here?
        }else{
          throw 'Could not upload photo. Please try again.';
        }
    });
    },
    fetchPropertyUnits( context, pid ){
      return new Promise( function( resolve ){
        if( context.getters.property( pid ) && context.getters.property( pid ).hasOwnProperty('units') ){
          //previously fetched, just resolve
          return resolve();
        }
        var fetchUnits = HttpHelper.actions.fetchAndStore( context, 'property/' + pid + '/units', 'storeUnits' );
        Promise.all( [ fetchUnits ] ).then( function(){
          resolve();
        });
      });
    },
    submitServiceIssue (context, data ){
      context.dispatch( 'postMessage', { msg : 'Submitting service issue...', timeout : 0 });
      return HttpHelper.actions.postWithToken( 'issue/', context.state.accessToken, data ).then( response => {
          if ( !response.body.hasOwnProperty( 'status' ) || response.body.status != 'OK'){
            throw 'Could not submit issue. Please try again.';
          }
      });
    }
  }
})

export default store;